<section class="d-flex flex-column flex-grow-1 position-relative h-100 overflow-auto">
  <router-outlet></router-outlet>

  @if (isLoading) {
    <app-loading></app-loading>
  }
</section>
